import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material.module';
import { UserPickerComponent } from './components/user-picker.component';
import { ReactiveFormsModule } from '@angular/forms';
import { EllipsisPipe } from './pipes/ellipsis.pipe';
import { ProjectNrPipe } from './pipes/project-nr.pipe';
import { FileUploadModule } from '../uploads/file-upload/file-upload.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FileUploadModule,
  ],
  declarations: [
    UserPickerComponent,
    EllipsisPipe,
    ProjectNrPipe
  ],
  exports: [
    UserPickerComponent,
    EllipsisPipe,
    ProjectNrPipe,
    FileUploadModule
  ],
  providers: [
    EllipsisPipe,
    ProjectNrPipe
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts